<template>
  <component :is="currentLayoutComponent" class="relative bg-dark-light rounded-lg p-3 h-[calc(100%-40px)]"></component>
</template>

<script>

import DeviceLayoutXuefengshan from './DeviceLayoutXuefengshan.vue';
import DeviceLayoutCity from './DeviceLayoutCity.vue';
import DeviceLayoutTransmitter from './DeviceLayoutTransmitter.vue';
import DeviceLayoutXuefengshanGlobal from './DeviceLayoutXuefengshanGlobal.vue';


export default {
  name: 'DeviceLayout',
  props: {
    selectedDeviceId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentLayoutComponent: DeviceLayoutXuefengshan
    };
  },

  watch: {
    selectedDeviceId(newVal) {
      switch (newVal) {
        case 'xuefengshan':
          this.currentLayoutComponent = DeviceLayoutXuefengshan;
          break;
        case 'city':
          this.currentLayoutComponent = DeviceLayoutCity;
          break;
        case 'transmitter':
          this.currentLayoutComponent = DeviceLayoutTransmitter;
          break;
        case 'xuefengshan_global':
          this.currentLayoutComponent = DeviceLayoutXuefengshanGlobal;
          break;
        default:
          this.currentLayoutComponent = DeviceLayoutXuefengshan;
      }
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.point-normal {
  background-color: #4caf50;
  box-shadow: 0 0 0.78125rem rgba(76, 175, 80, 0.7);
}
.point-warning {
  background-color: #ffc107;
  box-shadow: 0 0 0.78125rem rgba(255, 193, 7, 0.7);
}
.point-alarm {
  background-color: #f44336;
  box-shadow: 0 0 0.78125rem rgba(244, 67, 54, 0.7);
}
</style>